import { ExternalAnalyticsSDK } from '@modernhealth/analytics-core';
import { captureException, withScope } from '@sentry/minimal';

export interface Freshpaint extends ExternalAnalyticsSDK {
  reset: () => void;
}

/**
 * Previously, we were accessing Freshpaint using window.freshpaint, which
 * was potentially undefined and is a dangerous access pattern. This encapsulates
 * the global window access so that we can safely access Freshpaint within this file
 * and enforces that all callsites outside of this file are using a safe access pattern.
 * @returns A freshpaint instance (or undefined if initialization failed for some reason)
 */
export const getGlobalFreshpaint = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const dangerousWindow = window as any;
  if (typeof dangerousWindow.freshpaint === 'undefined') {
    withScope(scope => {
      scope.setTag('FreshPaint', 'Error initializing');
      captureException('Freshpaint is undefined');
    });
    return undefined;
  } else {
    return dangerousWindow.freshpaint as Freshpaint;
  }
};
